import { Client } from '@microsoft/microsoft-graph-client'
import { getAuthProvider } from './authProvider'
import { isMsalEnabled } from './authConfig'

let graphClient: Client | undefined

export const getGraphClient = () => {
  // If MSAL is disabled, return null
  if (!isMsalEnabled) {
    return
  }

  if (!graphClient) {
    const authProvider = getAuthProvider()
    // If authProvider is null (MSAL disabled), return null
    if (!authProvider) {
      return
    }

    graphClient = Client.initWithMiddleware({
      authProvider,
    })
  }
  return graphClient
}
